import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Lenis from '@studio-freight/lenis';
import EventsPage from './pages/EventsPage';
import EventDetailPage from './pages/EventDetailPage';
import ManageRSVPPage from './pages/ManageRSVPPage';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import EventManagement from './pages/admin/EventManagement';
import RSVPManagement from './pages/admin/RSVPManagement';
import './index.css';

// Global Lenis instance
let lenisInstance = null;

function App() {
  // Initialize Lenis smooth scroll
  useEffect(() => {
    try {
      lenisInstance = new Lenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        orientation: 'vertical',
        smoothWheel: true,
        smoothTouch: false,
      });

      function raf(time) {
        lenisInstance.raf(time);
        requestAnimationFrame(raf);
      }

      requestAnimationFrame(raf);

      // Make Lenis globally accessible for modals to control
      window.lenis = lenisInstance;

      return () => {
        if (lenisInstance) {
          lenisInstance.destroy();
        }
      };
    } catch (error) {
      console.warn('Lenis initialization failed:', error);
    }
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<EventsPage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/events/manage" element={<ManageRSVPPage />} />
        <Route path="/events/:slug" element={<EventDetailPage />} />
        
        {/* Admin Routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/events" element={<EventManagement />} />
        <Route path="/admin/events/:eventId/rsvps" element={<RSVPManagement />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
